import {
  AmountInfoSettingType,
  BankAccountType,
  BankReferenceBankType,
  BankType,
  CurrencyCode,
  CurrencyRatio,
  DateOptionType,
  DiscountType,
  DocumentFontType,
  DocumentFormat,
  DocumentHeaderSize,
  DocumentType,
  DocumentUpdatePassCodeType,
  EWalletProviderType,
  ExpenseType,
  FinanceType,
  HeaderOptionName,
  HeaderOptionType,
  ItemsDocumentType,
  LanguageType,
  MerchantType,
  PaymentElementType,
  PositionSummarizeDefault,
  ProductVatType,
  SettingAreaPunchingType,
  SettingCertifiedDate,
  TaxSourceType,
  TaxStatusType,
  TransactionType,
  WhtAmountType,
} from "@/enums/enums";
import { AddressDetailModel, MerchantAddressModel } from "../address/addressModel";
import { ContactModel, OrdinaryPersonModel } from "../contact/contactModel";
import { MerchantDetail } from "../merchant/merchantModel";
import { UserInfoModel } from "../user/userModel";
import { ContactEnvelopeDocumentTemplateModel } from "./contactEnvelopeModel";
import { ExecutiveSummaryDocumentTemplateModel } from "./executiveSummaryModel";
import { JournalDocumentTemplateModel } from "./journalDocumentModal";
import { PndDocumentTemplateModel } from "./pndDocumentModel";
import { PP30DocumentTemplateModel } from "./pp30DocumentModel";
import { SettingDocumentControlNoModel, SettingDocumentTemplateModel } from "./settingDocumentTemplate";
import { WithholdingTaxDocumentTemplateModel } from "./witholdingTaxDocumentModal";

export class ElementDefaultModel {
  value!: string;
  isShowElement!: boolean;

  constructor() {
    this.value = "";
    this.isShowElement = true;
  }
}

export class ElementHeadTypeModel {
  isShowDocumentSet!: boolean;
  isShowHeaderOptionType!: boolean;
  headerOptionType!: HeaderOptionType;
  originalAmount!: number;
  copyAmount!: number;
}

export class ElementDocumentNameModel extends ElementDefaultModel {
  headerOptionName!: HeaderOptionName;
  documentHeaderSize!: DocumentHeaderSize;
  isTaxInvoice!: boolean;
  isShowTaxInvoice!: boolean;
  isShowNonTaxInvoice!: boolean;
}

export class ElementDataContactInfoModel {
  phoneNumber!: ElementDefaultModel;
  website?: ElementDefaultModel;
  email!: ElementDefaultModel;
}

export class ElementDataMerchantContactInfoModel {
  phoneNumber!: ElementDefaultModel;
  website!: ElementDefaultModel;
  email!: ElementDefaultModel;
  line!: ElementDefaultModel;
  faxNumber!: ElementDefaultModel;
}

export class ElementMerchantModel extends ElementDataContactInfoModel {
  title!: string;
  isCustomTextDisplay!: boolean;
  isShowTextHeadOffice!: boolean;
  merchantName!: string;
  merchantType!: MerchantType;
  merchantAddress!: AddressDetailModel;
  merchantAddressTemplate!: MerchantAddressModel;
  merchantTaxId!: string;
  merchantBranchCode!: string;
}

export class ElementContactModel extends ElementDataContactInfoModel {
  isShowContact!: boolean;
  isCustomTextDisplay!: boolean;
  contactTitle!: string;
  contactName!: string;
  contactCode!: ElementDefaultModel;
  dearTitle!: ElementDefaultModel;
  ordinaryPerson!: OrdinaryPersonModel;
  dearName!: string;
  contactAddress!: string;
  contactTaxId!: string;
  contactBranchCode!: string;
  isOrdinaryPerson!: boolean;
  contactOrdinaryPerson!: OrdinaryPersonModel;
  contactMerchantType!: MerchantType;
  isShowTextHeadOffice!: boolean;
}

export class ElementDocumentInfoModel {
  dateOptionType!: DateOptionType;
  documentNoTitle!: ElementDefaultModel;
  issedDateTitle!: ElementDefaultModel;
  creditTitle!: ElementDefaultModel;
  acceptedDateTitle!: ElementDefaultModel;
  dueDateTitle!: ElementDefaultModel;
  refTitle!: ElementDefaultModel;
  taxInvoiceNumberTitle!: ElementDefaultModel;
  taxInvoiceDateTimeTitle!: ElementDefaultModel;
  documentNo!: string;
  issedDate!: Date;
  credit!: number;
  acceptedDate!: Date;
  dueDate!: Date;
  ref!: string;
  taxInvoiceNumber!: string;
  taxInvoiceDateTime!: Date;
  isCustomTextDisplay!: boolean;
  isShowIssueDateValue!: boolean;
}
export class ElementMerchantPersonModel extends ElementDataContactInfoModel {
  isShowMerchantPerson!: boolean;
  merchantPersonTitle!: ElementDefaultModel;
  merchantName!: ElementDefaultModel;
  isCustomTextDisplay!: boolean;
}

export class ElementAmountInfoModel {
  amountInfoSettingType!: AmountInfoSettingType;
  isCustomTextDisplay!: boolean;
  discountTitle!: ElementDefaultModel;
  nonVATAmountTitle!: ElementDefaultModel;
  zeroVATAmountTitle!: ElementDefaultModel;
  preVATAmountTitle!: ElementDefaultModel;
  vatAmountTitle!: ElementDefaultModel;
  netAmountTitle!: ElementDefaultModel;
  discount!: string;
  nonVATAmount!: number;
  zeroVATAmount!: number;
  preVATAmount!: number;
  vatAmount!: number;
  netAmountTh!: string;
  netAmountEn!: string;
  totalDocumentAmountAfterTitle!: ElementDefaultModel;
  referenceTransactionAmountTitle!: ElementDefaultModel;
  referenceTransactionAmount!: number;
  totalDocumentAmountAfter!: number;
}

export class ElementWithholdingModel {
  isCustomTextDisplay!: boolean;
  whtAmountTitle!: ElementDefaultModel;
  paymentAmountTitle!: ElementDefaultModel;
  whtAmount!: number;
  paymentAmount!: number;
}

export class ElementMerchantPaymentInfoModel {
  isshowPayment!: boolean;
  bankRefresh!: string;
  bankNumber!: string;
  bankName!: string;
  bankBranch!: string;
}

export class ElementMerchantPaymentModel {
  paymentElementType!: PaymentElementType;
  defaultPaymentMethodChannel!: DefaultPaymentMethodChannelModel;
  paymentGroups!: Array<PaymentGroupModel>;
  settingPaymentGroupList!: SettingPaymentGroupList;
  settingPaymentMethodChannel!: SettingPaymentMethodChannel;
}

export class SettingPaymentMethodChannel {
  isShowBankAccountName!: boolean;
  isShowBankAccountNumber!: boolean;
  isShowBankAccountBranchCode!: boolean;
  isShowBankAccountBranchName!: boolean;
}

export class SettingPaymentGroupList {
  isShowPaymentGroupList!: boolean;
  isShowPaymentGroupAll!: boolean;
  isShowBankAccountName!: boolean;
  isShowBankAccountNumber!: boolean;
  isShowBankAccountBranchName!: boolean;
}

export class ElementUserCreateModel {
  isShowSignatureUrl!: boolean;
  isShowCreateDate!: boolean;
  isShowCreateName!: boolean;
  signatureUrl!: string;
  name!: string;
  createDate!: Date;
}

export class ElementUserApproveModel {
  isShowSignatureUrl!: boolean;
  isShowApproveDate!: boolean;
  isShowApproveName!: boolean;
  signatureUrl!: string;
  name!: string;
  approveDate!: Date;
}

export class ElementUserReviewedModel {
  isShowSignatureUrl!: boolean;
  isShowReviewedDate!: boolean;
  signatureUrl!: string;
  name!: string;
  reviewedDate!: Date;
}

export class ElementExpenseClaimDetailModel {
  idCard!: ElementDefaultModel;
  expenseClaimNote!: ElementDefaultModel;
}

export class ElementCertifiedModel {
  userCreateTitle!: ElementDefaultModel;
  userApproveTitle!: ElementDefaultModel;
  merchantStampTitle!: ElementDefaultModel;
  receivedByTitle!: ElementDefaultModel;
  stampTitle!: ElementDefaultModel;
  userCreate!: ElementUserCreateModel;
  userApprove!: ElementUserApproveModel;
  merchantStampUrl!: ElementDefaultModel;
  isCustomTextDisplay!: boolean;
  isShowQRCode!: boolean;
  settingCreateDate!: SettingCertifiedDate;
  settingApproveDate!: SettingCertifiedDate;
}

export class ElementItemPriceModel {
  index!: number;
  isDescriptionOnly!: boolean;
  sequenceNumber!: number;
  description!: string;
  quantity!: number;
  price!: number;
  discount!: string;
  vatType!: string;
  preVatAmount!: number;
  incVatAmount!: number;
  whtAmount!: string;
  unit!: string;
  unitEn!: string;
}

export class ElementProductItemModel extends ElementItemPriceModel {
  productUrl!: string;
  productName!: string;
  productCode!: string;
  accountName!: string;
  accountNameEn!: string;
  accountCode!: string;
  productImages!: Array<DocumentProductImageModel>;
}

export class ElementAssetGroupItemModel extends ElementItemPriceModel {
  assetGroupCode!: string;
  name!: string;
  nameEn!: string;
}

export class ElementAssetItemModel extends ElementAssetGroupItemModel {
  assetCode!: string;
}

export class ElementBillingItemModel {
  index!: number;
  itemId!: number;
  isDescriptionOnly!: boolean;
  sequenceNumber!: number;
  description!: string;
  billedAmount!: number;
  billedCurrencyAmount!: number;
  document!: DocumentReferenceBilledModel;
  wht!: string;
}

export class ElementSettigColumnModel {
  isShowAmount!: boolean;
  isShowUnit!: boolean;
  isShowPrice!: boolean;
  isShowDiscount!: boolean;
  isShowVatAmount!: boolean;
  isShowPreVatAmount!: boolean;
  isShowIncVatAmount!: boolean;
  isShowWhtAmount!: boolean;
  isShowDocumentNumber!: boolean;
  isShowIssedDate!: boolean;
  isShowDueDate!: boolean;
  isShowBilledAmount!: boolean;
}

export class ElementSettigDescriptionModel {
  isShowImage!: boolean;
  isShowName!: boolean;
  isShowCode!: boolean;
  isShowDescription!: boolean;
}

export class HeaderDocumentModel {
  colorCode!: string;
  colorCodeCopy!: string;
  documentFontType!: DocumentFontType;
  documentFormat!: DocumentFormat;
  language!: LanguageType;
  areaPunchingType!: SettingAreaPunchingType;
  dateOptionType!: DateOptionType;
  merchantLogo!: ElementDefaultModel;
  isHaveEtaxInvoice!: boolean;
  isShowEtaxInvoice!: boolean;
  headType!: ElementHeadTypeModel;
  documentName!: ElementDocumentNameModel;
  merchant!: ElementMerchantModel;
  contact!: ElementContactModel;
  documentInfo!: ElementDocumentInfoModel;
  merchantPerson!: ElementMerchantPersonModel;
}

export class DetailDocumentModel {
  itemsDocumentType!: ItemsDocumentType;
  settigColumn!: ElementSettigColumnModel;
  settigDescription!: ElementSettigDescriptionModel;
  productList!: Array<ElementProductItemModel>;
  billingList!: Array<ElementBillingItemModel>;
  assets!: Array<ElementAssetItemModel>;
  assetGroups!: Array<ElementAssetGroupItemModel>;
  isShowWatermarkPaid!: boolean;
}

export class FooterDocumentModel {
  currencyCode!: string;
  amountInfo!: ElementAmountInfoModel;
  summarizeInfo!: ElementSummarizeInfoModel;
  payment!: ElementMerchantPaymentModel;
  remark!: ElementDefaultModel;
  reason!: ElementDefaultModel;
  certified!: ElementCertifiedModel;
  expenseClaimDetail!: ElementExpenseClaimDetailModel;
  documentControlNo!: SettingDocumentControlNoModel;

  constructor() {
    this.summarizeInfo = new ElementSummarizeInfoModel();
    this.payment = new ElementMerchantPaymentModel();
    this.remark = new ElementDefaultModel();
    this.reason = new ElementDefaultModel();
    this.certified = new ElementCertifiedModel();
    this.expenseClaimDetail = new ElementExpenseClaimDetailModel();
  }
}

export class ElementSummarizeInfoModel {
  isShowSummary!: boolean;
  isCustomTextDisplay!: boolean;
  positionSummarizeDefault!: PositionSummarizeDefault;
  summaryAmountTitle!: ElementDefaultModel;
  whtAmountTitle!: ElementDefaultModel;
  paymentAmountTitle!: ElementDefaultModel;
  summaryAmount!: number;
  whtAmount!: number;
  paymentAmount!: number;

  constructor() {
    this.summaryAmount = 0;
    this.whtAmount = 0;
    this.paymentAmount = 0;
    this.isCustomTextDisplay = false;
    this.positionSummarizeDefault = PositionSummarizeDefault.SummaryAmount;
  }
}

export class DocumentTemplateModel {
  transactionType!: TransactionType;
  financeType!: FinanceType;
  expenseType!: ExpenseType;
  headerOptionType!: number;
  header!: HeaderDocumentModel;
  detail!: DetailDocumentModel;
  footer!: FooterDocumentModel;
  isDeleted!: boolean;
  statusType!: number;
  currency!: CurrencyDetailModel;

  constructor() {
    this.header = new HeaderDocumentModel();
    this.detail = new DetailDocumentModel();
    this.footer = new FooterDocumentModel();
  }
}

export class CurrencyDetailModel {
  exchangeRates!: number;
  exchangeRatioType!: CurrencyRatio;
  fromCurrency!: FromToCurrencyModel;
  toCurrency!: FromToCurrencyModel;
  settingCurrency!: CurrencyCode;
}

export class DocumentIdModel {
  transactionType!: TransactionType | DocumentType;
  financeType!: FinanceType;
  transactionId!: number;
  sourceType?: TaxSourceType;
}
export class DocumentGeneratePdfModel {
  passCode!: string;
  transactionNumber!: string;
  documentName!: string;
  isDocumentNameShort!: boolean;
  transactionType!: TransactionType;
}
export class DocumentUpdateOnlineViewPassCodeModel extends DocumentIdModel {
  documentUpdatePassCodeType!: DocumentUpdatePassCodeType;
  transactionNumber!: string;
  documentName!: string;
  isDocumentNameShort!: boolean;
}
export class DocumentTemplateHeaderTypeModel extends DocumentIdModel {
  headerType!: number;
  headerTypeCode!: string;
}
export class DocumentWithPassCodeModel extends DocumentTemplateHeaderTypeModel {
  passCode!: string;
}
export class DocumentSaveSettingModel {
  documentId!: DocumentIdModel;
  documentTemplate!:
    | DocumentTemplateModel
    | JournalDocumentTemplateModel
    | WithholdingTaxDocumentTemplateModel
    | PP30DocumentTemplateModel
    | PndDocumentTemplateModel
    | ContactEnvelopeDocumentTemplateModel
    | ExecutiveSummaryDocumentTemplateModel;
  headerType!: number;
  documentNumber!: string;
}
export class DocumentSaveSettingOptionModel {
  isSaveSetting!: boolean;
  isSaveMainSetting!: boolean;
}

export class InputDoSetSetttingDefaultModel {
  transactionType!: number;
  financeType?: FinanceType;
  expenseType?: ExpenseType;
  headerOptionType?: number;
  toCurrency?: CurrencyCode;
}

export class OnlineViewModel {
  document!: DocumentDetailModel;
  template!: SettingDocumentTemplateModel;
  transactionId!: number;
  transactionType!: number;
  financeType!: number;
  expenseType!: number;
  credential!: CredentialModel;
  headerOptionType!: number;
}

export class OnlineViewCustomizeModel {
  customize!: CustomizeDocumentDataModel;
  document!: DocumentDetailModel;
  transactionId!: number;
  transactionType!: number;
  financeType!: number;
  expenseType!: number;
  credential!: CredentialModel;
}

export class CredentialModel {
  merchantCredential!: MerchantCredentialModel;
  userCredential!: Array<UserCredentialModel>;
  passCode!: string;

  constructor() {
    this.passCode = "";
  }
}
export class MerchantCredentialModel {
  stampUrl!: string;
}
export class UserCredentialModel {
  signatureUrl!: string;
  userId!: number;
}
export class DocumentDetailModel {
  data!: DocumentDataModel;
  version!: number;
  defaultPaymentMethodChannel!: DefaultPaymentMethodChannelModel;
}

export class CustomizeDocumentDataModel {
  css!: string;
  html!: string;
  id!: number;
}

export class DocumentDataModel {
  acceptedDateTime!: Date;
  acceptedUser!: UserInfoModel;
  approvedDateTime!: Date;
  approvedUser!: UserInfoModel;
  contact!: ContactModel;
  createdDateTime!: Date;
  createdUser!: UserInfoModel;
  currency!: DocumentCurrencyModel;
  discount!: DocumentDiscountModel;
  dueDateTime!: Date;
  isDeleted!: boolean;
  isSendETaxInvoice!: boolean;
  issuedDateTime!: Date;
  isTaxInvoice!: boolean;
  items!: Array<DocumentItemBaseModel>;
  billing!: Array<DocumentBillingBaseModel>;
  assets!: Array<DocumentItemAssetBaseModel>;
  assetGroups!: Array<DocumentItemAssetGroupBaseModel>;
  merchant!: MerchantDetail;
  reference!: DocumentReferenceModel;
  remark!: string;
  reason!: DocumentReasonModel;
  statusType!: number;
  summary!: DocumentSummaryModel;
  summaryDocumentModel!: DocumentCreditNoteandDebitNoteSummaryModel;
  tags!: Array<string>;
  taxStatusType!: TaxStatusType;
  transactionId!: number;
  transactionNumber!: string;
  updatedDateTime!: Date;
  updatedUser!: UserInfoModel;
  paymentGroups!: Array<PaymentGroupModel>;
  purchaseTaxInvoices!: DocumentPurchaseTaxInvoicesModel;
}

export class DocumentPurchaseTaxInvoicesModel {
  taxInvoiceDateTime!: Date;
  taxInvoiceNumber!: string;
}

export class DefaultPaymentMethodChannelModel {
  channelList!: Array<DocumentPaymentMethodModel>;
}
export class DocumentCurrencyModel {
  exchangeRates!: number;
  exchangeRatioType!: CurrencyRatio;
  fromCurrency!: FromToCurrencyModel;
  netAmount!: number;
  preVatTotal!: number;
  subTotal!: number;
  toCurrency!: FromToCurrencyModel;
  vatExemptedTotal!: number;
  vatTotal!: number;
  whtTotal!: number;
  zeroVatTotal!: number;
}
export class FromToCurrencyModel {
  currencyCode!: CurrencyCode;
}
export class DocumentSummaryModel {
  netAmount!: number;
  preVatTotal!: number;
  subTotal!: number;
  vatExemptedTotal!: number;
  vatTotal!: number;
  whtTotal!: number;
  zeroVatTotal!: number;
}
export class DocumentDiscountModel {
  discountAmount!: number;
  discountType!: DiscountType;

  constructor() {
    this.discountAmount = 0;
    this.discountType = DiscountType.Amount;
  }
}
export class DocumentReferenceModel {
  text!: string;
  document!: DocumentReferenceTypeModel;

  constructor() {
    (this.text = ""), (this.document = new DocumentReferenceTypeModel());
  }
}
export class DocumentReferenceTypeModel {
  transactionId!: number;
  transactionType!: TransactionType;
  transactionNumber!: string;
  constructor() {
    this.transactionId = 0;
    this.transactionType = TransactionType.None;
    this.transactionNumber = "";
  }
}

export class DocumentItemModel {
  index!: number;
  itemId!: number;
  isDescriptionOnly!: boolean;
  sequenceNumber!: number;
  description!: string;
}

export class DocumentItemPriceModel extends DocumentItemModel {
  vatAmount!: number;
  netAmount!: number;
  subTotal!: number;
  quantity!: number;
  price!: number;
  incVat!: number;
  vatType!: ProductVatType;
  wht!: DocumentWhtModel;
  discount!: DocumentDiscountModel;
  unit!: DocumentProductUnitModel;
}
export class DocumentItemBaseModel extends DocumentItemPriceModel {
  account!: DocumentAccountModel;
  product!: DocumentProductModel;
}

export class DocumentBillingBaseModel extends DocumentItemModel {
  billedAmount!: number;
  billedCurrencyAmount!: number;
  document!: DocumentReferenceBilledModel;
  wht!: DocumentWhtModel;
}

export class DocumentAssetGroupModel {
  assetGroupId!: number;
  assetGroupCode!: string;
  name!: string;
  nameEn!: string;
}

export class DocumentAssetModel {
  assetId!: number;
  assetCode!: string;
}

export class DocumentItemAssetGroupBaseModel extends DocumentItemPriceModel {
  assetGroup!: DocumentAssetGroupModel;
}

export class DocumentItemAssetBaseModel extends DocumentItemAssetGroupBaseModel {
  asset!: DocumentAssetModel;
}

export class DocumentReferenceBilledModel extends DocumentReferenceTypeModel {
  issuedDateTime!: Date;
  dueDateTime!: Date;
  transactionNetAmount!: number;
  transactionCurrencyNetAmount!: number;
  creditNote!: Array<DocumentReferenceCreditNoteModel>;
  exchangeRates!: number;
  exchangeRatioType!: CurrencyRatio;
}

export class DocumentReferenceCreditNoteModel {
  transactionId!: number;
  transactionNetAmount!: number;
  transactionNumber!: string;
  transactionType!: TransactionType;
  dueDateTime!: Date;
  exchangeRates!: number;
  exchangeRatioType!: CurrencyRatio;
  issuedDateTime!: Date;
  transactionCurrencyNetAmount!: number;
  fromCurrency!: FromToCurrencyModel;
  toCurrency!: FromToCurrencyModel;
}

export class PaymentGroupModel {
  paymentDateTime!: Date;
  paymentTotal!: number;
  payments!: Array<PaymentModel>;
  wht!: DocumentPaymentWhtModel;
  whtTotal!: number;
}

export class PaymentModel {
  amount!: number;
  paymentAccount!: DocumentAccountModel;
  paymentMethod!: DocumentPaymentMethodModel;
  paymentCheque!: DocumentChequeModel;
  paymentTransaction!: DocumentPaymentTransactionModel;
  remark!: string;
}
export class DocumentAccountModel {
  accountId!: number;
  accountCode!: string;
  name!: string;
  nameEn!: string;
}

export class DocumentChequeModel {
  chequeId!: number;
  chequeCode!: string;
  chequeNumber!: string;
  chequeDate!: Date;
  chequeBankReferenceId!: number;
}

export class DocumentPaymentMethodModel {
  paymentMethodId!: number;
  paymentMethodCode!: string;
  paymentMethodName!: string;
  paymentMethodType!: BankAccountType;
  bankReferenceType!: BankReferenceBankType;
  bankAccountType!: BankType;
  bankAccountNumber!: string;
  eWalletProviderType!: EWalletProviderType;
  eWalletNumber!: string;
  bankAccountBranchCode!: string;
  bankAccountBranchName!: string;
}
export class DocumentPaymentTransactionModel {
  transactionId!: number;
  transactionType!: TransactionType;
  transactionItemType!: ExpenseType;
  transactionNumber!: string;
}
export class DocumentProductModel {
  productId!: number;
  productCode!: string;
  name!: string;
  productImages!: Array<DocumentProductImageModel>;
}
export class DocumentProductImageModel {
  imageUrl!: string;
  isSelected!: boolean;
}
export class DocumentReasonModel {
  reasonDescription!: string;
  reasonId!: number;
}

export class DocumentCreditNoteandDebitNoteSummaryModel {
  totalDocumentAmountAfter!: number;
  referenceTransactionAmount!: number;

  constructor() {
    this.totalDocumentAmountAfter = 0;
    this.referenceTransactionAmount = 0;
  }
}

export class DocumentProductUnitModel {
  unitId!: number;
  name!: string;
  nameEn!: string;
}
export class DocumentWhtModel {
  whtAmount!: number;
  whtAmountType!: WhtAmountType;
}

export class DocumentPaymentWhtModel extends DocumentWhtModel {
  whtNumber!: number;
}

export class ColumnModel {
  isShowColumn!: boolean;
  width!: number;
  align!: string;
}

export class HeaderItemColumnModel {
  productImage!: ColumnModel;
  description!: ColumnModel;
  quantity!: ColumnModel;
  unit!: ColumnModel;
  price!: ColumnModel;
  discount!: ColumnModel;
  vat!: ColumnModel;
  preVatAmount!: ColumnModel;
  incVatAmount!: ColumnModel;
  whtAmount!: ColumnModel;
}

export class HeaderBillingColumnModel {
  documentNumber!: ColumnModel;
  issuedDateTime!: ColumnModel;
  dueDateTime!: ColumnModel;
  preVatAmount!: ColumnModel;
  billedAmount!: ColumnModel;
  whtAmount!: ColumnModel;
}
